import { useState } from "react"
import {
    TABLES_LENGTH_SKELETON,
    TABLES_POSITIONS_SKELETON,
    TABLES_DIMENSIONS_SKELETON,
} from "src/shared/constants/localStorage"
import "./SkeletonTableCards.css"

type SavedPosition = { x: number; y: number }
type SavedDimensions = { x: number; y: number }

function SkeletonTableCard() {
    return (
        <div className="table-skeleton__card">
            <div className="table-skeleton__header">
                <div className="table-skeleton__icon skeleton-item-base" />
                <div className="table-skeleton__header-right">
                    <div className="table-skeleton__pill skeleton-item-base" />
                    <div className="table-skeleton__pill table-skeleton__pill--lg skeleton-item-base" />
                </div>
            </div>
            <div className="table-skeleton__body">
                <div className="table-skeleton__bar skeleton-item-base" />
            </div>
            <div className="table-skeleton__footer">
                <div className="table-skeleton__pill skeleton-item-base" />
            </div>
        </div>
    )
}

function SkeletonTableCards(): JSX.Element {
    const [tablesLength] = useState(Number(localStorage.getItem(TABLES_LENGTH_SKELETON) || 12))
    const [positions] = useState<SavedPosition[]>(() => {
        try { return JSON.parse(localStorage.getItem(TABLES_POSITIONS_SKELETON) || "[]") }
        catch { return [] }
    })
    const [dimensions] = useState<SavedDimensions | null>(() => {
        try { return JSON.parse(localStorage.getItem(TABLES_DIMENSIONS_SKELETON) || "null") }
        catch { return null }
    })

    const hasLayout = positions.length > 0 && dimensions !== null

    if (hasLayout) {
        return (
            <div className="tables-skeleton__wrapper">
                <div
                    className="tables-skeleton__grid"
                    style={{
                        gridTemplate: `repeat(${dimensions!.x}, 1fr) / repeat(${dimensions!.y}, 1fr)`,
                    }}
                >
                    {positions.map((pos, i) => (
                        <div
                            key={i}
                            style={{ gridArea: `${pos.y} / ${pos.x} / span 1 / span 1` }}
                        >
                            <SkeletonTableCard />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div className="tables-skeleton__wrapper">
            <div className="tables-skeleton__cards">
                {Array.from({ length: tablesLength }, (_, i) => (
                    <SkeletonTableCard key={i} />
                ))}
            </div>
        </div>
    )
}

export default SkeletonTableCards
